<div class="container">
  <section class="main">
    <header class="header">
      <mat-icon>donut_large</mat-icon><span>AI Sales Coach</span>
    </header>
    <div class="content">
      <h1>認証アプリの設定</h1>
      <p>Authenticator などの認証アプリで QR コードを読み取ってください。</p>
      @if (preparing) {
        <p>準備しています…</p>
      }
      @if (needsNewSecret) {
        <button
          rectangle
          [disabled]="preparing || busy"
          (click)="regenerateSecret()"
        >
          QR コードを再生成
        </button>
      }
      @if (qrCodeDataUrl) {
        <img
          [src]="qrCodeDataUrl"
          alt="認証アプリ登録用 QR コード"
          width="200"
          height="200"
        />
        <form [formGroup]="form" (ngSubmit)="submit()">
          <label for="code">6 桁の認証コード</label>
          <input
            id="code"
            formControlName="code"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="6"
          />
          <button rectangle type="submit" [disabled]="busy || form.invalid">
            登録
          </button>
        </form>
      }
      @if (errorMessage) {
        <p role="alert">{{ errorMessage }}</p>
      }
      <button rectangle variant="secondary" [disabled]="busy" (click)="back()">
        戻る
      </button>
    </div>
  </section>
</div>
